import "./CategoryCard.css";

export function CategoryCard({image}) {
  return (
    <div className="category-card">
        <img width={"112px"} src={image} alt="" />

        <div className="content-card">
          <h3>Medicos Especialistas</h3>
        </div>
    </div>
  );
}